<ion-split-pane contentId="main-content">
  <ion-menu contentId="main-content" type="overlay">
    <ion-content>
      <app-current-user-card></app-current-user-card>
      <ion-list id="inbox-list">
        <ion-list-header class="app-header">
          <span>Exascan</span>
        </ion-list-header>
        <div>
          <ion-note>
            <ion-badge color="primary">v{{ version() }}</ion-badge>
          </ion-note>
        </div>
        <div>
          <ion-note>AP Hogeschool</ion-note>
        </div>

        @for (p of appPages; track p; let i = $index) {
        <ion-menu-toggle auto-hide="false">
          <ion-item routerDirection="root" [routerLink]="[p.url]" lines="none" detail="false"
            routerLinkActive="selected">
            <ion-icon aria-hidden="true" slot="start" [ios]="p.icon + '-outline'" [md]="p.icon + '-sharp'"></ion-icon>
            <ion-label>{{ p.title }}</ion-label>
          </ion-item>
        </ion-menu-toggle>
        }
      </ion-list>
      @if (canInstall()) {
      <ion-button expand="block" color="primary" (click)="installApp()" class="install-button">
        <ion-icon slot="start" name="download-outline"></ion-icon>
        App installeren
      </ion-button>
      }
      <ion-button expand="block" color="danger" (click)="logout()" class="logout-button">
        <ion-icon slot="start" name="log-out-outline"></ion-icon>
        Uitloggen
      </ion-button>
    </ion-content>
  </ion-menu>
  <ion-router-outlet id="main-content"></ion-router-outlet>
</ion-split-pane>